module.exports = __webpack_public_path__ + "static/media/Checkbox@3x.0536d230.png";